<template>
  <!--
描述：插件中心-主播
-->
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName">
                <el-tab-pane label="主播管理" name="anchor">
                    <Anchor v-if="activeName=='anchor'"></Anchor>
                </el-tab-pane>
                <el-tab-pane label="主播预告" name="notice">
                    <Notice v-if="activeName=='notice'"></Notice>
                </el-tab-pane>
                <el-tab-pane label="任务积分" name="coin">
                    <Coin v-if="activeName=='coin'"></Coin>
                </el-tab-pane>
            </el-tabs>        
        </div>
    </div>
</template>

<script>
    import AnchorApi from '@/api/anchor.js';
    import Anchor from './anchor/Index.vue';
    import Notice from './notice/index.vue';
    import Coin from './coin/index.vue';

    export default {
        components: {
            Anchor,
            Notice,
            Coin
        },
        data() {
            return {
                activeName: 'anchor',
                /*是否加载完成*/
                loading: true,
            }
        },
        created() {


        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/views/plus/anchor/index.vue